import React from "react";
import { NumberInput, required, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { scholarshipRequests } from "api/scholarshipApi";
import { Button } from "@mui/material";
const AddScholarshipBudgetDialog = ({ fiscalYear, structuralUnitId, structuralUnitName }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      amount: data.amount,
    };
    await dataProvider.customRequest(
      scholarshipRequests.addScholarshipBudgetForStructuralUnit(fiscalYear, structuralUnitId),
      payload,
      "POST",
    );
    notify(`Успешно добавихте бюджет за факултет ${structuralUnitName}`, { type: "success" });
    refresh();
  };
  return (
    <FormModal
      titleContent={`Добави бюджет за ${structuralUnitName}`}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant="contained"
          startIcon={<AddBoxIcon />}
          size="small"
        >
          Добави
        </Button>
      }
    >
      <NumberInput
        source="amount"
        label="Сума"
        validate={required()}
      />
    </FormModal>
  );
};

export default AddScholarshipBudgetDialog;
